import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IRegistrationState } from './state';

export const GETREGISTERDATA = 'getRegistrierungData';

export const getters: GetterTree<IRegistrationState, IRootState> = {
    [GETREGISTERDATA]: state => state.registrierungData
};
